import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { DEFAULT_UI_LANGUAGE } from '../i18n/language';

/** Redirect / → /fr preserving ?returnTo= & ?surface= query params. */
const RootLangRedirect: React.FC = () => {
  const location = useLocation();
  return <Navigate to={`/${DEFAULT_UI_LANGUAGE}${location.search}`} replace />;
};

export default RootLangRedirect;
